import React, { createContext, useContext, useEffect, useState } from "react";
import { getAllSessions, getMeta, setMeta, saveSession as dbSave, deleteSession as dbDelete } from "../lib/db";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

const FREE_LIMIT = 5;

export function AppProvider({ children }) {
  const [sessions, setSessions] = useState([]);
  const [unlocked, setUnlocked] = useState(false);
  const [voiceURI, setVoiceURI] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [clientId, setClientId] = useState("");

  useEffect(() => {
    (async () => {
      const s = await getAllSessions();
      setSessions(s);
      setUnlocked(await getMeta("unlocked", false));
      setVoiceURI(await getMeta("voice", null));
      let cid = await getMeta("clientId", null);
      if (!cid) { cid = crypto.randomUUID(); await setMeta("clientId", cid); }
      setClientId(cid);
      setLoaded(true);
    })();
  }, []);

  const refresh = async () => setSessions(await getAllSessions());

  const addSession = async (session) => {
    await dbSave(session);
    await refresh();
  };

  const removeSession = async (id) => {
    await dbDelete(id);
    await refresh();
  };

  const unlock = async () => {
    await setMeta("unlocked", true);
    setUnlocked(true);
  };

  const chooseVoice = async (uri) => {
    await setMeta("voice", uri);
    setVoiceURI(uri);
  };

  const usedCount = sessions.length;
  const canAsk = unlocked || usedCount < FREE_LIMIT;
  const remaining = Math.max(0, FREE_LIMIT - usedCount);

  return (
    <AppContext.Provider value={{
      sessions, loaded, unlocked, voiceURI, clientId,
      addSession, removeSession, refresh, unlock, chooseVoice,
      usedCount, canAsk, remaining, FREE_LIMIT,
    }}>
      {children}
    </AppContext.Provider>
  );
}
